/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export const confirm = ({ callbackFunc, title, yesText, noText }) => {
  const options = {
    title: "Title",
    message: "Message",
    buttons: [
      {
        label: "Yes",
        onClick: () => alert("Click Yes")
      },
      {
        label: "No",
        onClick: () => alert("Click No")
      }
    ],
    childrenElement: () => <div />,
    customUI: ({ onClose }) => (
      <div className="custom-ui-alert">
        <h1>{title || 'Xác nhận'} </h1>
        <div className="box">
          <div className="bg-d9534f" onClick={onClose}>{noText || 'Không, cần xem lại'}</div>
          <div className="bg-c7c6c5" onClick={() => {
            callbackFunc();
            onClose();
          }}> { yesText || 'Có, tiếp tục' } </div>
        </div>
      </div>
    ),
    closeOnEscape: true,
    closeOnClickOutside: true,
    willUnmount: () => { },
    onClickOutside: () => { },
    onKeypressEscape: () => { }
  };

  confirmAlert(options);
}

// module.exports = {
//   confirm
// }